"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustoHook = void 0;
const interfaces_1 = require("../interfaces");
const components_1 = require("./components");
const texts_1 = require("./texts");
const data_1 = require("./data");
class CustoHook {
    constructor(fn, type, isSafe, transformationFn) {
        this.$$end$$ = true;
        this.type = interfaces_1.CustoType.component;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        this.transformationFn = transformationFn;
        this.use = function (...args) {
            let returnValue = fn(...args);
            if (that.transformationFn && !(returnValue instanceof CustoHook)) {
                returnValue = that.transformationFn(returnValue);
            }
            while (returnValue instanceof CustoHook) {
                if (!returnValue.isSafe) {
                    that.isSafe = false;
                }
                const pass = returnValue.use(...args);
                returnValue = that.transformationFn
                    ? that.transformationFn(pass)
                    : pass;
            }
            return returnValue;
        };
        this.type = type;
        this.unsafelyGetOriginalFn = () => fn;
        this.isSafe = isSafe;
    }
    static createHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, false);
    }
    static createFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, true);
    }
    static createHookOfHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, false);
    }
    static createHookOfFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, false);
    }
    static createFnOfHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, true);
    }
    static createFnOfFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.hook, true);
    }
    static createComponentHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.component, false, ensureComponent);
    }
    static createComponentFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.component, true, ensureComponent);
    }
    static createTextHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.text, false, ensureCustoText);
    }
    static createTextFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.text, true, ensureCustoText);
    }
    static createDataHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.data, false, ensureCustoData);
    }
    static createDataFn(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.data, true, ensureCustoData);
    }
    static createRawDataHook(fn) {
        return new CustoHook(fn, interfaces_1.CustoType.data, false);
    }
    getFuncVersion() {
        const comp = this.clone();
        comp.isSafe = true;
        return comp;
    }
    getHookVersion() {
        const comp = this.clone();
        comp.isSafe = false;
        return comp;
    }
    clone() {
        return new CustoHook(this.use, this.type, this.isSafe, this.transformationFn);
    }
}
exports.CustoHook = CustoHook;
function ensureCustoData(data) {
    if (data instanceof data_1.CustoData) {
        return data.data;
    }
    return data;
}
function ensureCustoText(data) {
    if (data instanceof texts_1.CustoText) {
        return data;
    }
    return texts_1.CustoText.create(data);
}
function ensureComponent(data) {
    if (data instanceof components_1.CustoComponent) {
        return data;
    }
    return components_1.CustoComponent.create(data);
}
